/** Scrolls to the FoldingCard with this id and opens it if it's folded; false when it isn't on the page. */
export function showFoldingCard(id: string): boolean {
  const el = document.getElementById(id);
  if (!el) return false;
  if (el.dataset.state === 'closed') el.querySelector<HTMLElement>(':scope > [data-slot=collapsible-trigger]')?.click();
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}
